import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';

const EsOrderBrListItemBlock = styled.div`
    position: relative;
    padding-top: 20px;
    padding-bottom: 20px;
    //border-bottom: 1px solid #cccccc;
    padding: 20px 16px;
`;

const EsOrderBrListItemImgBlock = styled.div`
    ${isMobileOnly?`
    width: 98px;
    float: left;
    height: 98px;
    `:`
    margin-left: 20px;
    width: 100px;
    float: left;
    height: 100px;
    `};

`;

const EsOrderBrListItemTextBlock = styled.div`
    padding: 0 20px;
    float: left;
    width: 420px;
`;

const EsOrderBrListItemTitleBlock = styled.p`
    display: -webkit-box;
    height: 42px;
    font-size: 14px;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #333333;
`;

const EsOrderBrListItemOptionBlock = styled.div`
    position: absolute;
    bottom: 40px;
    color: #666666;
    font-size: 14px;
`;

const EsOrderBrListItemQtyBlock = styled.div`
    position: absolute;
    bottom: 20px;
    color: #999999;
    font-size: 14px;
`;

const EsOrderBrListItemPriceBlock = styled.div`
    float: right;
    width: 158px;
    text-align: right;
    vertical-align: middle;
    line-height: 1.5;
    display: table;
    height: 100px;
    padding-right: 20px;
`;

const EsOrderBrListItemPriceInnerBlock = styled.div`
    vertical-align: middle;
    display: table-cell;
`;


const MobileEsOrderBrListItemBlock = styled.div`
    padding: 20px 16px 0px;
`;

const MobileEsOrderBrListItemInfoBlock = styled.div`
      height: 98px;
`;

const MobileEsOrderBrListItemNameContainerBlock = styled.div`
    float: left;
    width: calc(88vw - 122px);
    padding-left: 10px;
`;

const MobileEsOrderBrListItemNameBlock = styled.div`
    font-size: 14px;
    font-weight: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: left;
    color: #333333;
    margin-bottom: 10px;

    max-height: 42px;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
`;

const MobileEsOrderBrListItemOptionBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #666666;
    margin-bottom: 10px;
`;

const MobileEsOrderBrListItemNumBlock = styled.div`
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: #999999;
    margin-bottom: 10px;
`;

const MobileEsOrderBrListItemControlBlock = styled.div`
    //margin-top: 10px;
    position: relative;
    //padding-right: 16px;
`;

const EsOrderPckgProdImgBtnBlock = styled.img`
    border-radius: 4px;
    min-width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
`;

const EsOrderDeliveryBlock = styled.div`
    ${isMobileOnly?`
    padding: 7px 10px;
    margin: 20px 0 0px;
    `:`
    padding: 7px 20px;
    margin: 0 16px;
    `};

    position: relative;
    height: 32px;
    background-color: #fafafa;
    
`;

const EsOrderDeliveryTextBlock = styled.div`
    float: right;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 18px;
    color: #999999;
    text-align: right;

    ::before {
        content: '';
        display: inline-block;
        width: 22px;
        height: 13px;
        margin-right: 8px;
        background: url(/assets/images/icon/truck.svg) center center/auto no-repeat;
        vertical-align: -2px;
    }
`;
const EsOrderBrListItem = ({item}) => {

    

    const isOptionDisp = () => {
        if (item.opt_nm === null || item.opt_nm === '' ||
            item.opt_nm === item.prdct_nm) {
            return 'none';
        } else {
            return 'block';
        }
    }

    const getDlvryPrice = () => {

        // 선불
        if (item.es_detail_dlvry_pay_type === '025201') {
            return (<p className='f-right'>선불 배송비<span> {Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}</span>원</p>)
        } else if (item.es_detail_dlvry_pay_type === '025202') { // 착불
            return (<p className='f-right'>예상 착불 배송비<span> {Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}</span>원</p>)
        } else {
            return (<p className='f-right'>무료배송</p>)
        }
    }

    return (isMobileOnly? //mobile
        <MobileEsOrderBrListItemBlock>
            <MobileEsOrderBrListItemInfoBlock className="clearfix">
                <EsOrderBrListItemImgBlock>
                    <EsOrderPckgProdImgBtnBlock src={item.repr_img}/>
                </EsOrderBrListItemImgBlock>
                <MobileEsOrderBrListItemNameContainerBlock>
                    <MobileEsOrderBrListItemNameBlock>{item.prdct_nm}</MobileEsOrderBrListItemNameBlock>
                    {item.opt_nm&&<MobileEsOrderBrListItemOptionBlock>
                    {item.opt_nm}
                    </MobileEsOrderBrListItemOptionBlock>}
                    <MobileEsOrderBrListItemNumBlock >
                    <p><span>수량 : {item.qty}개</span></p>
                    </MobileEsOrderBrListItemNumBlock>
                </MobileEsOrderBrListItemNameContainerBlock>
                
            </MobileEsOrderBrListItemInfoBlock>
            <MobileEsOrderBrListItemControlBlock className="clearfix">
                
                <div style={{float: 'right', paddingTop: '0px'}}>
                    <SpanPckgNavPrice value={item.es_detail_total_price}
                    fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                </div>  
                <div style={{float: 'right', marginRight: '8px', paddingTop: '2px'}}>
                <SpanPckgNavPrice value={item.es_detail_prdct_price} fontSize='12px' fontWeight='500' wonFontSize='12px' float='none' isSale={true}/>
                </div>   
            </MobileEsOrderBrListItemControlBlock>
            <EsOrderDeliveryBlock> 
                <EsOrderDeliveryTextBlock>{getDlvryPrice()}</EsOrderDeliveryTextBlock>
            </EsOrderDeliveryBlock>
        </MobileEsOrderBrListItemBlock>
        : //desktop
        <div className="clearfix">
        <EsOrderBrListItemBlock className="clearfix">
            <EsOrderBrListItemImgBlock>
                <EsOrderPckgProdImgBtnBlock src={item.repr_img}/>
            </EsOrderBrListItemImgBlock>
            <EsOrderBrListItemTextBlock>
                <EsOrderBrListItemTitleBlock>
                    {item.prdct_nm}
                </EsOrderBrListItemTitleBlock>
                <EsOrderBrListItemOptionBlock style={{ display: isOptionDisp() }}>
                    <p><span>옵션 : {item.opt_nm}</span></p>
                </EsOrderBrListItemOptionBlock>
                <EsOrderBrListItemQtyBlock >
                    <p><span>수량 : {item.qty}개</span></p>
                </EsOrderBrListItemQtyBlock>
            </EsOrderBrListItemTextBlock>
            <EsOrderBrListItemPriceBlock>
                <EsOrderBrListItemPriceInnerBlock>
                <SpanPckgNavPrice value={item.es_detail_prdct_price} fontSize='12px' fontWeight='300' wonFontSize='12px' float='none' isSale={true}/>
                    <SpanPckgNavPrice value={item.es_detail_total_price}
                    fontSize='14px' fontWeight='500' wonFontSize='14px' float='none' />
                </EsOrderBrListItemPriceInnerBlock>
            </EsOrderBrListItemPriceBlock>
        </EsOrderBrListItemBlock>
        <EsOrderDeliveryBlock> 
            <EsOrderDeliveryTextBlock>{getDlvryPrice()}</EsOrderDeliveryTextBlock>
        </EsOrderDeliveryBlock>
        </div>
    );
};

export default EsOrderBrListItem;